module.exports = __webpack_public_path__ + "img/KM-360C.a763b8c4.png";